// eslint-disable-next-line wix-custom-rules/wixstores-file-names
import {createGlobalConfig} from '@wix/fe-essentials-viewer-platform/panorama-client';

export const getGlobalConfig = (() => {
  const globalConfigInstance = createGlobalConfig();

  return () => globalConfigInstance;
})();
